/**
* Contact Form JS
* -----------------------------------------------------------------------------
*
* All the JS for the Contact Form component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'contact-form',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let top = $( '.navbar' ).outerHeight();
      if ( $( '.logged-in' ).length ) {
        top += 32;
      }
      const tl = gsap.timeline( {
        scrollTrigger: {
          trigger: '.contact-form',
          scrub: true,
          start: `top top+=${top}`,
          end: 'bottom top',
        },
      } );
      tl.to( '.contact-form__scroll-shift', {x: '-600px'} );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'contact-form', COMPONENT );
} )( app );
